// Actions
export const ADD_COLLECTION = 'companyExperience/entities/interviewRequestEventFeedbacks/ADD_COLLECTION'
export const ADD_ITEM = 'companyExperience/entities/interviewRequestEventFeedbacks/ADD_ITEM'

// Action Creators
export const addCollection = collection => ({
  type: ADD_COLLECTION,
  payload: collection.map(item => addItem(item.id, item)),
})

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_COLLECTION:
      return {
        ...state,
        ...payload.reduce((map, item) => {
          map[item.meta.id] = entity(state[item.meta.id], { type: item.type, payload: item.payload })
          return map
        }, {}),
      }

    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getInterviewRequestEventFeedbackMap = state => state.entities.interviewRequestEventFeedbacks || defaultMap
export const getInterviewRequestEventFeedbackItem = (state, id) => state.entities.interviewRequestEventFeedbacks[id] || defaultEntity
